import { useContext, useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { fetchtotalid } from "../CustSearch/apiSearch";
import { FilterContext } from "../../context/Filter";

const Fleetidtable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { superArn: parArn, childArn } = useContext(FilterContext);
  const [citylist, setCitylist] = useState("")

  const key = childArn ? "childArn" : "parArn";
  const value = childArn || parArn;
  const payload = { [key]: value };

  const fetchData = async () => {
    if (!value) return;
    setLoading(true);
    try {
      const result = await fetchtotalid(payload);

      const arrayData = (
        Array.isArray(result) ? result : Object.values(result)
      ).map((item, index) => ({
        rowHeader: ` ${index + 1}`,
        name: item.PAR_ACCNT_NAME,
        email: item.ACCNT_EMAIL || "N/A",
        fleetId: item.FLEET_ID,
        parentArn: item.PAR_ACCNT_ARN,
        parentAccountName: item.PAR_ACCNT_NAME,
        childArn: item.ACCNT_ARN,
        childAccountName: item.ACCNT_NAME,
        chassisNo: item.ASSET_NUMBER,
      }));

      setData(arrayData);
    } catch (error) {
      console.error("Error fetching fleet ID data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parArn, childArn]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "rowHeader",
        header: "",
        size: 120, // fixed width
        Cell: ({ row }) => (
          <div className="text-center"
            style={{
              height: "60px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div className=" text-center" style={{ fontWeight: "bold" }}>{row.original.rowHeader}</div>
          </div>
        ),
        muiTableBodyCellProps: {
          sx: {
            backgroundColor: "#f1f5f9",
            padding: 0,
            minWidth: "120px",
            maxWidth: "120px",
            width: "120px",
          },
        },
        muiTableHeadCellProps: {
          sx: {
            minWidth: "120px",
            maxWidth: "120px",
            width: "120px",
          },
        },
      },
      { accessorKey: "fleetId", header: "Fleet ID" },
      { accessorKey: "parentArn", header: "Golden Arn" },
      { accessorKey: "parentAccountName", header: "Parent Account Name" },
      { accessorKey: "childArn", header: "Child ARN" },
      { accessorKey: "childAccountName", header: "Child Account Name" },
      { accessorKey: "chassisNo", header: "Chassis No" },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    state: { isLoading: loading },
    enableColumnResizing: true,
    muiTableContainerProps: {
      sx: {
        maxHeight: "300px", // scroll after ~3 rows (60px * 3 + header)
        overflowY: "auto",
      },
    },
    muiTableHeadRowProps: { sx: { backgroundColor: "#1E70B0" } },
    muiTableHeadCellProps: { sx: { color: "white", fontWeight: "bold" } },
  });

  return (
    <div className="p-2 text-gray-300">
      <MaterialReactTable table={table} />
      {!loading && data.length === 0 && (
        <div className="text-center text-gray-500 h-24">No Data Found</div>
      )}
    </div>
  );
};

export default Fleetidtable;
